import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { sortHumanReadable } from '@iotv/datamodel-core';
import { AdjacentType, ComparisonType } from '@iotv/iotv-v3-types';
import { FormControl, InputLabel, MenuItem, Select, Toolbar } from '@mui/material';
import { useEffect, useState } from 'react';
import { getAdjacent2Wrapper } from '../../../../data/daoFunctions/daoFunctions';
export const TypeByCustomer = (props) => {
    const { updateParams: setParamsInParent, keyPress, index, attKey, children, selected } = props;
    const [parents, setParents] = useState();
    const [selectedContext, setSelectedContext] = useState();
    useEffect(() => {
        const valid = { type: '', id: '', sk: '', pk: '' };
        const relatedThingsParams = {
            scopeDefinitingContextObject: valid,
            includeEdges: false,
            adjacencyType: AdjacentType.SUBJECT,
            objectTypeId: 'Customer',
        };
        getAdjacent2Wrapper(relatedThingsParams).then((resultPromise) => {
            if (resultPromise.err === null && resultPromise.data) {
                const objects = resultPromise.data.Items;
                setParents(sortHumanReadable(objects, 'name'));
            }
            else {
                setParents([]);
            }
        });
    }, []);
    useEffect(() => {
        if (selectedContext && selected) {
            setParamsInParent([{ key: attKey, value: `${selectedContext.pk}`, predicate: ComparisonType.EQUALS }], index);
        }
        else {
            setParamsInParent(undefined, index);
        }
    }, [selectedContext, selected]);
    const changeParent = (e) => {
        setSelectedContext(parents?.find((parent) => parent.id === e.target.value));
    };
    return (_jsxs(Toolbar, { children: [children, _jsx("div", { style: { flexGrow: 1 }, children: _jsxs(FormControl, { fullWidth: true, children: [parents !== undefined && _jsx(InputLabel, { id: "property-label", children: parents?.length === 0 ? 'N/A' : '' }), _jsx(Select, { size: "small", disabled: parents?.length === 0, labelId: "customer-label", id: "customer-select", value: selectedContext?.id, onChange: changeParent, onKeyDown: keyPress, children: parents?.map((parent) => {
                                return _jsx(MenuItem, { value: parent.id, children: parent.name });
                            }) })] }) })] }));
};
